module.exports = __webpack_public_path__ + "static/img/logo twitter.d716d19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo twitter.png
// module id = 2hZA
// module chunks = 0